<div class="sidebar-button" (click)="openModal()">
  <p>Feedback</p>
</div>
